import { ArrowDownRight } from "lucide-react";
import { KEYWORDS } from "../lib/content";

const HERO_BG =
  "https://customer-assets.emergentagent.com/job_sublime-landing/artifacts/2faihgu5_hero-sublime.webp";

export default function Hero() {
  const scroll = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden bg-[#0D0D0D] pt-24"
    >
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_BG}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover"
          loading="eager"
        />
        {/* Purple #7030A0 tinted overlay */}
        <div
          className="absolute inset-0"
          style={{ backgroundColor: "rgba(112, 48, 160, 0.62)" }}
        />
        {/* Top-to-bottom contrast for legibility & smooth transition into next section */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#0D0D0D]/55 via-[#0D0D0D]/15 to-[#FCFAFF]" />
        <div className="absolute inset-0 grain pointer-events-none" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 lg:px-14 pt-12 md:pt-20 pb-20">
        {/* Tag row */}
        <div className="flex items-center gap-3 mb-10 md:mb-14" data-testid="hero-tag">
          <span className="inline-block w-10 h-px bg-white/80" />
          <span className="font-body uppercase text-[11px] md:text-xs tracking-[0.32em] text-white/85">
            Agencia Creativa 360° · Guadalajara, MX
          </span>
        </div>

        <div className="grid grid-cols-12 gap-6 lg:gap-10 items-end">
          {/* Headline */}
          <div className="col-span-12">
            <h1
              data-testid="hero-title"
              className="font-display font-medium text-[15vw] sm:text-[12vw] lg:text-[10.5vw] leading-[0.92] tracking-[-0.04em] text-white drop-shadow-[0_2px_24px_rgba(13,13,13,0.35)]"
            >
              <span className="block">marketing</span>
              <span className="block italic font-editorial font-light text-[#E9D6F2] -mt-2 md:-mt-4">
                sublime<span className="text-white">.</span>
              </span>
            </h1>
          </div>
        </div>

        {/* Subheadline & CTA */}
        <div className="mt-12 md:mt-16 grid grid-cols-12 gap-6 lg:gap-10">
          <div className="col-span-12 md:col-span-7">
            <p
              data-testid="hero-subtitle"
              className="font-editorial text-2xl md:text-3xl lg:text-4xl leading-[1.25] text-white text-balance"
            >
              Diseñamos <em className="text-[#F0DCFA]">ecosistemas de marca</em> que conectan emocionalmente con el consumidor — donde la estética se fusiona con la estrategia.
            </p>
          </div>
          <div className="col-span-12 md:col-span-5 flex md:justify-end items-end">
            <div className="flex flex-col gap-4 w-full md:w-auto">
              <button
                data-testid="hero-cta-primary"
                onClick={() => scroll("contacto")}
                className="group inline-flex items-center justify-between gap-6 px-7 py-5 rounded-full bg-white text-[var(--ms-ink)] font-body text-[15px] tracking-wide hover:bg-[var(--ms-ink)] hover:text-white transition-all duration-500"
              >
                <span>Iniciar un proyecto</span>
                <span className="flex items-center justify-center w-9 h-9 rounded-full bg-[var(--ms-purple)]/15 group-hover:bg-white/15 group-hover:rotate-[-45deg] transition-all duration-500">
                  <ArrowDownRight size={16} />
                </span>
              </button>
              <button
                data-testid="hero-cta-secondary"
                onClick={() => scroll("servicios")}
                className="font-body text-[14px] tracking-wide text-white/85 hover:text-white underline underline-offset-4 decoration-[#E9D6F2] decoration-1 self-start md:self-end transition"
              >
                Ver nuestros servicios →
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Marquee keywords */}
      <div className="relative z-10 border-y border-white/15 bg-[#0D0D0D]/35 backdrop-blur-md py-5 overflow-hidden">
        <div className="flex animate-marquee whitespace-nowrap" data-testid="hero-marquee">
          {[...Array(2)].map((_, i) => (
            <div key={i} className="flex items-center gap-12 px-6 shrink-0">
              {KEYWORDS.map((kw, idx) => (
                <span key={`${i}-${idx}`} className="flex items-center gap-12">
                  <span className="font-display text-2xl md:text-3xl tracking-tight text-white">
                    {kw}
                  </span>
                  <span className="text-[#E9D6F2] text-2xl">✦</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
